module.exports = __webpack_public_path__ + "img/Frame 428t3.8f63b755.svg";